var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-container'),_c('content-container'),_c('card-container'),_c('bottom-container')],1)}
var staticRenderFns = []

export { render, staticRenderFns }